import React from 'react'
import {Button, Modal, ModalBody,Col, Form, Input, CardBody, Media, FormFeedback } from 'reactstrap';
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
export const DialogSendEmail = (props) => {
  const { toggleEmail, email, handleInputChange, saveEmail, loading, modalEmail, saveEmailDoctor, validacionesEmail } = props;

      const {
		email_valid
	} = validacionesEmail;

    const footer = (
      <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>

          <Button 
              color="primary" 
              size="sm"
              onClick={saveEmailDoctor}
              disabled={loading}
              style={{
                  padding: "2px",
                  fontSize: "12px",
                  height: "31px",
                  width: "70px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
              }}
              
          >
              Enviar
          </Button>


          <Button 
              color="danger" 
              size="sm"
              onClick={toggleEmail}
              disabled={loading}
              style={{
                  padding: "2px",
                  fontSize: "12px",
                  height: "31px",
                  width: "85px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
              }}
          >
              Cancelar
          </Button>
      </div>
    );

  return (
   <Dialog
    visible={modalEmail}
    header="Envío de accesos a micrositio"
    onHide={toggleEmail}
    modal
    closable={true}
    dismissableMask={false} 
    className='medium-dialog'
    footer={footer}

>

      <div className="p-fluid">
        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <img
            src={require("../../assets/images/loginHelenLabs/User/email.svg")}
            alt=""
            style={{
              width: "80px",
              height: "80px",
              borderRadius: "50%",
            }}
          />

          <div>
            <h6 className="font-primary f-w-600">
              Envío de accesos a micrositio
            </h6>

            <span className="d-block f-14 pt-3">
              En caso de requerir más de un correo separarlos con
              <span className="txt-secondary"> , </span>
            </span>
          </div>
        </div>

        <div style={{ marginTop: "20px" }}>
           <InputTextarea
              name="email"
              value={email}
              required
              autoComplete="off"
              onChange={handleInputChange}
              placeholder="Correo(s)"
              className="w-full"
              rows={2}
              style={{ resize: "none" }}
              invalid={email_valid}
            />
            {email_valid && (
                <small className="p-error" style={{ fontSize: "12px" }}>
                    Ingresa un correo
                </small>
            )}

        </div>
      </div>
    </Dialog>
  );
};